<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-autocomplete
      :value="driver"
      :items="drivers"
      :label="label === null ? $i18n.t('Driver') : $i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      :disabled="disabled"
      autocomplete="off"
      :no-filter="true"
      :append-outer-icon="disabled === false ? 'mdi-magnify' : ''"
      @click:append-outer="
        showGrid1 = true;
        driverCreateDialog = true;
      "
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      v-if="btn === false"
    >
      <template v-slot:selection="data">
        <div ripple class="height32" v-if="multiple === false">
          <v-img
            :src="data.item.pic"
            height="20"
            width="24"
            style="float: left; margin-right: 10px"
          ></v-img>
          <div style="width: 90px; float: left; font-size: 14px">
            {{ data.item.name }}
          </div>
          <div style="min-width: 82px; float: left; font-size: 14px">
            {{ data.item.phone }}
          </div>
        </div>
        <div ripple v-else>
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            <v-img
              :src="data.item.pic"
              height="20"
              width="24"
              style="float: left; margin-right: 10px"
            ></v-img>
            <div style="float: left; font-size: 12px">{{ data.item.name }}</div>
          </div>
        </div>
      </template>
      <template v-slot:item="data" class="px-2">
        <v-list-item ripple class="px-0">
          <v-list-item-content class="px-0">
            <v-list-item-title class="px-0">
              <v-img
                :src="data.item.pic"
                height="20"
                width="24"
                style="float: left; margin-right: 10px"
              ></v-img>
              <div style="width: 90px; float: left; font-size: 12px">
                {{ data.item.name }}
              </div>
              <div style="min-width: 82px; float: left; font-size: 12px">
                {{ data.item.phone }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="driverCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Driver") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>

    <z-driver-create
      @select="select"
      :showDialog="driverCreateDialog"
      :showGrid1="showGrid1"
    ></z-driver-create>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import orderBy from "lodash/upperFirst";

@Component({
  name: "DriverSelect",
  props: {
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: null,
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
    helper: {
      default: false,
    },
    employee: {
      default: false,
    },
  },
})
export default class DriverSelect extends (Vue, Themeable) {
  rows = 20;
  url = "/api/driver/grid?rows=";
  name = "";
  showGrid1 = false;
  countryCode = null;
  phone = null;
  supplier = null;
  on = null;
  page = 1;
  dialog = false;
  selected = [];
  driver = null;
  drivers = [];
  filter = "";
  filterUrl = "";
  driverCreateDialog = false;

  async mounted() {
    await this.onValueChange(this.value);
  }

  get loading() {
    return common.loading;
  }

  select(driver) {
    this.dialog = false;
    this.driverCreateDialog = false;
    if (driver) {
      this.driver = driver;
      this.drivers = [driver];
      if (this.idOnly === false) {
        this.$emit("input", driver);
      } else {
        this.$emit("input", driver._id);
      }
    }
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.driver = newVal;
      if (this.idOnly === false) {
        this.$emit("input", newVal);
      } else {
        this.$emit("input", newVal._id);
      }
    } else {
      // this.$emit("input", null);
    }
  }

  clear() {
    this.filter = "";
    this.driver = null;
    this.$emit("input", null);
  }

  @Watch("filter")
  async onFilterChange(val) {
    if (val != null && val.length > 1 && val.length < 20) {
      const filter = val.toLowerCase();
      let url = "/api/driver/autofill?key=" + filter;
      if (this.helper === "" || this.helper) {
        url = url + "&helper=true";
      } else if (this.employee === "" || this.employee) {
        url = url + "&employee=true";
      } else {
        url = url + "&driver=true";
      }
      const drivers = await doGet();
      if (drivers != null && drivers.length > 0) {
        orderBy(drivers, ["name", "phone"], ["asc", "asc"]);
        this.drivers = drivers;
      } else {
        this.drivers = [];
      }
      if (this.drivers != null && this.drivers.length > 0 && focus)
        this.show = true;
    }
  }

  @Watch("value")
  async onValueChange() {
    this.driver = null;
    if (this.idOnly === false) {
      if (this.value && !this.value.isAdhoc && this.value._id) {
        common.setLoading(true);
        this.driver = await doGet(
          "/api/driver/" +
            (this.value._id ? this.value._id : "null") +
            "/driverDetail"
        );
        common.setLoading(false);
        this.drivers = [this.driver];
      } else if (this.value) {
        this.driver = this.value;
        this.drivers = [this.value];
      }
    } else if (this.value) {
      if (!this.value.isAdhoc) {
        common.setLoading(true);
        this.driver = await doGet(
          "/api/driver/" + this.value + "/driverDetail"
        );
        common.setLoading(false);
        this.drivers = [this.driver];
      } else {
        this.driver = this.value;
        this.drivers = [this.value];
      }
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
